import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {ColonistCoinProduct} from './ColonistCoinProduct'
import {ColonistMembershipProduct} from './ColonistMembershipProduct'
import {ColonistOneTimePurchaseProduct} from './ColonistOneTimePurchaseProduct'

export enum PaymentMethod {
    Stripe,
    Xsolla,
    Discord,
    None,
    Apple,
    Android,
}

export enum PaymentProvider {
    Stripe,
    Xsolla,
}

export enum StoreProductType {
    Coin,
    Membership,
    OneTimePurchase,
}

export enum StripeCheckoutTypes {
    Payment = 'payment',
    Subscription = 'subscription',
}

export interface LocalizedStoreSubscriptionData {
    subscriptionId: string
    localizedPrice: string
}

export interface LocalizedStoreProductData {
    productId: string
    localizedPrice: string
}

export interface BaseColonistStoreProduct {
    storeProductType: StoreProductType
    type: number
    lobbyImage: LobbyImage
    stripePriceId: string
    stripeCheckoutType: StripeCheckoutTypes
    itemQuantity: number
    isActive: () => boolean
    getProductName(): TranslationObject
    getDefaultPrice(): string
}

export function deserializeStoreProduct(storeProductType: StoreProductType, type: number, itemQuantity: number): BaseColonistStoreProduct {
    switch(storeProductType) {
        case StoreProductType.Coin: return ColonistCoinProduct.getPurchaseProduct(type)
        case StoreProductType.Membership: return ColonistMembershipProduct.getMembershipProduct(type)
        case StoreProductType.OneTimePurchase: return ColonistOneTimePurchaseProduct.getOneTimePurchaseProduct(type, itemQuantity)
    }
}
